import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_DASHBOARD} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Dashboard = lazy(() =>
  import('../../../screens/Dashboard')
    .then(module => ({default: module.Dashboard})));

const DashboardNavigation = [
  {
    path: ROUTE_DASHBOARD,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Dashboard />
      </Suspense>
    ),
  },
];

export default DashboardNavigation;
